export default "__VITE_ASSET__DIjonykc__"